<template>
  <div class="app-info-page">
    <div :class="['app-status-box', ['status-wait', 'status-reject', 'status-pass', 'status-stop'][appStatus - 1]]" v-if="appStatus"></div>
    <el-form ref="appForm"
             class="form-content form-error-right"
             :model="editInfo"
             label-position="right"
             label-width="150px">
      <el-form-item label="未通过原因" v-if="appStatus === 2">
        <span class="text-warning">{{appFailureReason}}</span>
      </el-form-item>
      <el-form-item label="应用编号" class="mb-sm">
        <span>{{editInfo.app_id}}</span>
      </el-form-item>
      <el-form-item label="应用名称">
        <span>{{editInfo.app_name}}</span>
      </el-form-item>
      <el-form-item label="应用图标" prop="app_img_url" :rules="rules.app_img_url" class="is-required">
        <el-upload ref="upload"
                   v-loading="uploadLoading"
                   class="upload-box"
                   action="/ajax/common/interface/image/upload"
                   :headers="headerData"
                   :show-file-list="false"
                   name="image"
                   accept="image/jpg,image/jpeg,image/png"
                   :before-upload="beforeFileUpload"
                   :on-success="uploadSuccess"
                   :on-error="uploadError">
          <img v-if="editInfo.app_img_url" :src="editInfo.app_img_url" class="app-upload-img">
        </el-upload>
        <div class="upload-tips">图片支持格式为 JPEG、JPG、PNG<br/>图片大小不能超过2M</div>
      </el-form-item>
      <el-form-item prop="call_back" :rules="rules.call_back" label-width="170px">
        <span slot="label">
          <span class="span-box">
            <span>授权回调地址</span>
            <el-tooltip style="display:inline" effect="dark" content="授权时接收code参数的地址" placement="top-start">
              <i class="call-back-top-logo el-icon-warning-outline"/>
            </el-tooltip>
          </span>
        </span>
        <el-input class="call-back-input" v-model="editInfo.call_back" maxlength="100" clearable placeholder="请输入应用授权回调地址"></el-input>
      </el-form-item>
      <el-form-item label="公司/个人" class="mb-sm">
        <span>{{editInfo.company_name}}</span>
      </el-form-item>
      <el-button class="edit-submit-btn" @click="appSubmit">提交</el-button>
    </el-form>
  </div>
</template>

<script>
  export default {
    name: 'controlAppInfo',
    data() {
      return {
        headerData: {
          Authorization: localStorage.getItem('token')
        },
        editInfo: {
          app_id: '',
          app_name: '', // 应用名称
          app_img_url: '', // 应用图标
          company_name: '', // 公司名称
          call_back: '' // 回调地址
        },
        appStatus: '',
        appFailureReason: '',
        uploadLoading: false,
        rules: {
          company_name: [
            {required: true, message: '请输入公司名称', trigger: 'blur'}
          ],
          app_img_url: [
            {required: true, message: '请上传应用图标', trigger: 'blur'}
          ],
          call_back: [
            {required: true, message: '请输入应用的回调地址', trigger: 'blur'}
          ],
        }
      }
    },
    mounted() {
      this.editInfo.app_id = this.$route.params.appId;
      this.getDetail();
    },
    methods: {
      // 获取详情
      getDetail() {
        this.server.post("/ajax/control/panel/app/info", {
          app_id: this.editInfo.app_id
        }).then(res => {
          let detail = res.data.data;
          this.editInfo.app_name = detail.app_name;
          this.editInfo.app_img_url = detail.app_img_url;
          this.editInfo.company_name = detail.company_name;
          this.editInfo.call_back = detail.call_back;
          this.appStatus = detail.status;
          this.appFailureReason = detail.failure_reason;
        });
      },
      // 图片预览
      funPreImg(img) {
        this.imgPreview.data = img;
        this.imgPreview.show = true;
      },
      beforeFileUpload(file) {
        const isLimitSize = file.size / 1024 / 1024 < 2;
        if (!isLimitSize) {
          this.$message.error('图片不能大于2M');
        } else {
          this.uploadLoading = true
        }
        return isLimitSize
      },
      uploadSuccess(res, file) {
        this.uploadLoading = false
        if (res.ret === 0) {
          this.editInfo.app_img_url = res.data
          this.$refs.appForm.validateField('app_img_url')
        } else {
          this.$refs.upload.clearFiles()
        }
      },
      uploadError(res, file) {
        this.uploadLoading = false
        this.$message.error('上传图片失败')
      },
      // 提交
      appSubmit() {
        if(this.isLoading) {
          return
        }
        this.$refs.appForm.validate(valid => {
          if (valid) {
            this.showCommonLoading();
            this.server.post("/ajax/control/panel/app/edit", this.editInfo).then(res => {
              this.hideCommonLoading();
              if (res.data.ret === 0) {
                this.$message.success('修改成功');
                this.getDetail();
              }
            }).catch(e => {
              this.hideCommonLoading();
            });
          }
        })
      },
    }
  }
</script>

<style lang="scss">
  .app-info-page {
    .form-content {
      .el-form-item__label {
        padding-right: 34px;
        font-size: 16px;
      }
      .el-form-item__content {
        font-size: 16px;
        color: #666;
      }
    }
    .upload-box {
      display: inline-block;
      width: 80px;
      height: 80px;
      vertical-align: middle;
      .el-upload {
        width: 80px;
        height: 80px;
        background: url("../../../assets/img/control/icon_upload.png");
        background-size: 100% 100%;
      }
      .app-upload-img {
        width: 100%;
        height: 100%;
        vertical-align: top;
      }
    }
    .upload-tips {
      display: inline-block;
      margin-left: 7px;
      color: #9E9E9E;
      font-size: 12px;
      line-height: 16px;
      position: relative;
      top: 30px;
    }
  }
</style>
<style lang="scss" scoped>
  .app-info-page {
    padding: 20px 0 30px;
    box-sizing: border-box;
    position: relative;
    .app-status-box {
      position: absolute;
      top: 10px;
      right: 28px;
      width: 164px;
      height: 164px;
      &.status-pass {
        background: url("../../../assets/img/control/status_pass.png");
        background-size: 100% 100%;
      }
      &.status-wait {
        background: url("../../../assets/img/control/status_wait.png");
        background-size: 100% 100%;
      }
      &.status-reject {
        background: url("../../../assets/img/control/status_reject.png");
        background-size: 100% 100%;
      }
      &.status-stop {
        background: url("../../../assets/img/control/status_stop.png");
        background-size: 100% 100%;
      }
    }
    .form-content {
      width: 500px;
      margin-left: 140px;
      .edit-submit-btn {
        width: 350px;
        background: #F16622;
        color: #fff;
        margin-left: 150px;
        margin-top: 20px;
        border: none;
      } 
    }
    .call-back-top-logo {
      font-size: 16px;
    }
    .call-back-input {
      margin-left: -21px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/control/app/info.vue